import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import './policy.css';

const CookiePolicy: React.FC = () => {
  useEffect(() => {
    // Initialize Termly script using their exact implementation
    const initializeTermly = () => {
      const d = document;
      const s = 'script';
      const id = 'termly-jssdk';
      
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://app.termly.io/embed-policy.min.js";
      fjs.parentNode?.insertBefore(js, fjs);
    };

    initializeTermly();

    return () => {
      // Cleanup on unmount
      const script = document.getElementById('termly-jssdk');
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <Layout>
      <div className="policy-page">
        <div className="policy-content">
          <h1>Cookie Policy</h1>
          {/* @ts-ignore */}
          <div name="termly-embed" data-id="f923e8a0-eba9-49f1-8e06-2826b3f3f6ee"></div>
        </div>
      </div>
    </Layout>
  );
};

export default CookiePolicy; 